<template>
  <div class="catalogSubsetProductsList">
    <div class="catalogSubsetProductsList__actions">
      <form-multiselect
        :options="[
          { value: 'addToBasket', label: 'Dodaj do koszyka' },
          { value: 'addToShoppingList', label: 'Dodaj do listy zakupowej' },
        ]"
        v-model="action"
        key-value="value"
        option-label="label"
        open-direction="top"
        placeholder="Wybierz częstotliwość"
      />
      <VButton text="Wykonaj" theme="purple" small-height @click="runAction" />
    </div>
    <div class="catalogSubsetProductsList__header">
      <div class="catalogSubsetProductsList__headerName">Nazwa produktu</div>
      <div class="catalogSubsetProductsList__headerPrice">Cena</div>
      <div class="catalogSubsetProductsList__headerCheckbox">
        <FormCheckbox
          id="selectAllProducts"
          v-model="selectAllProducts"
          name="selectAllProducts"
          label="Zaznacz wszystkie"
          is-reverse
          @change="selectAll"
          is-medium
        />
      </div>
    </div>
    <div class="catalogSubsetProductsList__list">
      <div
        class="catalogSubsetProductsList__listItem"
        v-for="product in products"
        :key="product.id"
      >
        <catalog-subset-products-list-item
          :product="product"
          @change="e => changeCount(e, product)"
        >
          <template #checkbox>
            <FormCheckbox
              :id="product.id"
              :value="product.id"
              v-model="selectedProducts"
              is-medium
            />
          </template>
        </catalog-subset-products-list-item>
      </div>
    </div>
  </div>
</template>

<script>
import listMixin from '~/mixins/list.js';
import cartMixin from '~/mixins/cart.js';
import CatalogSubsetProductsListItem from '@/components/CatalogSubset/CatalogSubsetProductsListItem.vue';
import FormCheckbox from '@/components/Form/FormCheckbox.vue';
import VButton from '@/components/VButton.vue';
import FormMultiselect from '@/components/Form/FormMultiselect.vue';

export default {
  name: 'CatalogSubsetProductsList',
  components: { FormMultiselect, VButton, FormCheckbox, CatalogSubsetProductsListItem },
  mixins: [listMixin, cartMixin],
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectAllProducts: false,
      selectedProducts: [],
      itemsBasketCount: [],
      action: 'addToBasket',
    };
  },
  watch: {
    selectedProducts(val) {
      this.selectAllProducts = val.length === this.products.length;
    },
  },
  created() {
    this.itemsBasketCount = this.products.map(item => ({
      item: {
        id: item.id,
      },
      quantity: 1,
    }));
  },
  methods: {
    changeCount(e, item) {
      if (this.itemsBasketCount) {
        const updatedItem = this.itemsBasketCount.find(
          basketItem => basketItem.item.id === item.id,
        );

        if (updatedItem) {
          updatedItem.quantity = e;
        } else {
          console.warn('Nie znaleziono elementu w koszyku o ID:', item.id);
        }
      }
    },
    selectAll(e) {
      if (e) {
        this.selectedProducts = this.products.map(item => item.id);
      } else {
        this.selectedProducts = [];
      }
    },
    runAction() {
      const mappedItems = this.itemsBasketCount
        .map(item => ({
          item: {
            id: item.item.id,
          },
          quantity: item.quantity ? item.quantity : 1,
        }))
        .filter(mappedItem => this.selectedProducts.includes(mappedItem.item.id));

      if (this.action === 'addToBasket') {
        this.storeAddProductsToCart({ products: mappedItems });
      }
      if (this.action === 'addToShoppingList') {
        this.toggleProductFromList({ product: null, isOnList: false, products: mappedItems });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.catalogSubsetProductsList {
  $root: &;
  background-color: $cWhite;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;

  &__actions {
    display: flex;
    gap: 1rem;
    padding: 2rem 2rem 1.5rem 2rem;
    justify-content: flex-end;

    ::v-deep {
      .formMultiselect {
        min-width: 24rem;
        padding-top: 0;

        @include rwd('tablet') {
          min-width: 16rem;
        }

        @include rwd('phone') {
          min-width: 14rem;
        }
      }
    }
  }

  &__header {
    display: flex;
    padding: 1.5rem 2rem 0.9rem;
    font-size: 1.4rem;
    line-height: 1.42;
    color: $cMainNeutral;
    border-top: 1px solid $cAddLight;
    border-bottom: 1px solid $cAddLight;
  }

  &__headerName {
    margin-left: 11.5%;
    padding-left: 1rem;
    flex: 0 0 38%;
    max-width: 38%;
    padding-right: 4rem;

    @include rwd('laptop') {
      flex: 0 0 30%;
      max-width: 30%;
    }

    @include rwd('tablet') {
      display: none;
    }
  }

  &__headerPrice {
    @include rwd('tablet') {
      display: none;
    }
  }

  &__list {
    padding-bottom: 0;
  }

  &__headerCheckbox {
    margin-left: auto;
  }

  &__listItem {
    position: relative;

    &:after {
      content: '';
      position: absolute;
      left: 2rem;
      bottom: 0;
      width: calc(100% - 4rem);
      height: 1px;
      background-color: $cAddLight;
    }

    &:last-child {
      &:after {
        display: none;
      }
    }
  }
}
</style>
